import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  FLOWS_PROGRESS,
  FLOWS_SUCCESS,
  FLOWS_FAILED,
  FLOWS_GET_LIST_PROGRESS,
  FLOWS_GET_LIST_SUCCESS,
  FLOWS_GET_LIST_FAILED,
  FLOWS_FORM_SUBMIT_PROGRESS,
  FLOWS_FORM_SUBMIT_SUCCESS,
  FLOWS_FORM_SUBMIT_FAILED,
  FLOWS_GET_COURSE_PROGRESS,
  FLOWS_GET_COURSE_SUCCESS,
  FLOWS_GET_COURSE_FAILED,
  FLOWS_GET_ASYNC_DATA_PROGRESS,
  FLOWS_GET_ASYNC_DATA_SUCCESS,
  FLOWS_GET_ASYNC_DATA_FAILED,
  FLOWS_CLEAR_STATE,
  FLOWS_CLEAR_FLASH_MESSAGE,
} from '../actions/flowsAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FLOWS_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: FLOWS_PROGRESS },
      });
    }
    case FLOWS_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: FLOWS_SUCCESS },
      });
    }
    case FLOWS_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: FLOWS_FAILED },
      });
    }
    case FLOWS_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: FLOWS_PROGRESS } });
    }
    case FLOWS_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: FLOWS_SUCCESS },
      });
    }
    case FLOWS_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: FLOWS_FAILED } });
    }
    case FLOWS_GET_COURSE_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: FLOWS_PROGRESS },
      });
    }
    case FLOWS_GET_COURSE_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.flow },
        loadActiveStatus: { $set: FLOWS_SUCCESS },
      });
    }
    case FLOWS_GET_COURSE_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: FLOWS_FAILED },
      });
    }
    case FLOWS_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: FLOWS_PROGRESS },
      });
    }
    case FLOWS_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: FLOWS_SUCCESS },
      });
    }
    case FLOWS_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: FLOWS_FAILED },
      });
    }
    case FLOWS_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case FLOWS_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
